<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogRoleRenewal" persistent max-width="950px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">ต่ออายุสิทธิ์</span>
        <v-btn absolute right top icon x-small @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-row justify="center" align="center">
        <v-col cols="11" class="text-center ">
          <v-divider
          ></v-divider>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row align="center">
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="" style="color: #3776E9;">ข้อมูลสิทธิ์การโอน</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="10">
                  <span>ชื่อสิทธิ์ย่อย: {{subRole}}</span>
                </v-col>
                <v-col cols="10">
                  <span>สถานะ: {{status}} </span>
                </v-col>
                <v-col cols="10">
                  <span>Tag: {{tag}} </span>
                </v-col>
                <v-col cols="10">
                  <span>รูปแบบการอนุมัติ: {{approveType}}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="" style="color: #3776E9;">ระยะเวลาการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="10">
                  <span>วันที่โอนสิทธิ์: {{initDate(this.startTransferDate)}} </span>
                </v-col>
                <v-col cols="10">
                  <span>ระยะเวลาการรับสิทธิ์: {{initDate(this.startWorkDate)}} - {{initDate(this.endWorkDate)}} </span>
                </v-col>
                <v-col cols="10">
                  <span>ใกล้หมดอายุ : {{this.nearExpire}} วัน</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <div class="mt-4">
          <span class="ra-head-text-bold pa-1" style="color: #3776E9;">กำหนดระยะเวลาการโอนสิทธิ์</span>
        </div>
        <v-row justify="center" align="center">
          <v-col cols="12" class="text-center ">
            <v-divider
            ></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="4" lg="4">
            <span>วันที่เริ่มต้น</span><span style="color: red;"> *</span>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              disabled
            >
            <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startWorkDate"
                  placeholder="เลือกวันที่เริ่ม"
                  persistent-hint
                  readonly
                  v-on="on"
                  outlined
                  dense
                  disabled
                >
                <template v-slot:append>
                  <img width="20" height="20" src="@/assets/icons/today.png" >
                </template>
                </v-text-field>
            </template>
            <v-date-picker
                v-model="startWorkDate"
                no-title
                @input="menu = false"
            ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4" sm="4" md="4" lg="4">
            <span>วันที่่สิ้นสุด</span><span style="color: red;"> *</span>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endWorkDate"
                  placeholder="เลือกวันที่สิ้นสุด"
                  persistent-hint
                  readonly
                  v-on="on"
                  outlined
                  dense
                >
                <template v-slot:append>
                  <img width="20" height="20" src="@/assets/icons/today.png" >
                </template>
                </v-text-field>
            </template>
            <v-date-picker
                v-model="endWorkDate"
                no-title
                @input="menu2 = false"
            ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn class="ra-button1 mx-2" color="#1654C6" outlined @click="dialogConfirmCancel = true">ยกเลิกสิทธิ์</v-btn> -->
          <v-btn class="ra-button1 mx-2" color="#1654C6" outlined @click="closeDialog">ยกเลิก</v-btn>
          <v-btn class="ra-button1 mx-2" color="#1654C6" dark @click="submitData()">บันทึก</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmCancel" max-width="500px">
    <v-card height="180px">
      <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกสิทธิ์นี้ใช่ไหม</v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสิทธิ์</span>
      </v-card-text>
      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmCancel = false">ยกเลิก</v-btn>
        <v-btn class="ra-button1" color="#1654C6" dark @click="submitCancelRole()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import
{
// hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'
const moment = require('moment')

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      menu: false,
      menu2: false,
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogRoleRenewal: false,
      dialogConfirmCancel: false,
      startWorkDate: '',
      endWorkDate: '',
      selected: [],
      itemUser: [],
      total: -1,
      perPage: 15,
      page: 1,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      // approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader',
      approveRole: 'Admin',
      searchEmpoyee: '',
      dataSearchEmployee: '',
      typeAction: '',
      roleNotExpireData: '',
      subRole: '',
      status: '',
      tag: '',
      approveType: '',
      startTransferDate: '',
      endTransferDate: '',
      nearExpire: '',
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('dialogRoleRenewal')
  },
  async mounted () {
    await EventBus.$on('dialogRoleRenewal', this.openDialogRenewal)
  },
  watch: {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsId = this.$route.params.id
    // this.getUser()
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogRenewal (value, item, action, index, type) {
      // console.log('id', value)
      this.propsId = value
      await this.getRoleExpireDetail(value)
      this.loading = true
      this.dialogRoleRenewal = true
      this.loading = false
    },
    closeDialog () {
      this.dialogRoleRenewal = false
    },
    clearSearchEmployee () {
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    initDateConvert (date) {
      // return moment(date).format('DD/MM/YYYY')
      return moment(date).format('YYYY-MM-DD')
    },
    async getRoleExpireDetail (id) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenTransferById`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          // authenId: '6188d3137467641a4d807e7b',
          authenId: id,
          search: '',
          position: [''],
          positionLevel: [''],
          limit: 15,
          page: 1
        }
      }).then((response) => {
        this.subRole = response.data.result[0].authenName
        this.status = this.statusList.filter(e => e.status === response.data.result[0].status)[0].statusTH
        this.approveType = response.data.result[0].conditions === 'all' ? 'อนุมัติทุกคน' : 'อนุมัติแค่คนใดคนหนึ่ง'
        this.startTransferDate = response.data.result[0].createAt
        this.startWorkDate = this.initDateConvert(response.data.result[0].startDate)
        this.endWorkDate = this.initDateConvert(response.data.result[0].endDate)
        this.tag = response.data.result[0].tag[0] ? response.data.result[0].tag[0].name : 'ไม่มี'
        // this.startWorkDate = '2021-11-09'
        this.endTransferDate = response.data.result[0].endDate
        this.nearExpire = response.data.result[0].statusExpire === true ? 'หมดอายุ' : response.data.result[0].expire
        this.roleNotExpireData = response.data.result[0].transfer
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async submitCancelRole () {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/cancelAuthen`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsId,
          userId: ''
        }
      }).then((response) => {
        if (response.data.success) {
          swal('สำเร็จ', 'ยกเลิกสิทธิ์สำเร็จ', 'success', {
            button: false,
            timer: 1000
          })
          this.getRoleExpireDetail(this.propsId)
          this.loading = false
          this.dialogConfirmCancel = false
          this.dialogRoleRenewal = false
          EventBus.$emit('closeDialogAuthen')
        } else {
          swal('ผิดพลาด', 'ยกเลิกสิทธิ์ไม่สำเร็จ', 'error', {
            button: false,
            timer: 1500
          })
        }
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async submitData () {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/renewAuthen`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsId,
          endDate: this.endWorkDate
        }
      }).then((response) => {
        // this.subRole = response.data.result[0].authenName
        if (response.data.success) {
          swal('สำเร็จ', 'ต่อสิทธิ์สำเร็จ', 'success', {
            button: false,
            timer: 1000
          })
          this.getRoleExpireDetail(this.propsId)
          this.loading = false
          this.dialogRoleRenewal = false
          EventBus.$emit('closeDialogAuthen')
        } else {
          swal('ผิดพลาด', 'ต่อสิทธิ์ไม่สำเร็จ', 'error', {
            button: false,
            timer: 1500
          })
        }
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
